import { useEffect, useState, useContext, useRef } from 'react'

import useStore from '../../store/useStore'
import InitDatePicker from './DatePicker'
import styles from './index.module.scss';
import { Select, DatePicker } from 'antd';
import type { DatePickerProps } from 'antd';

import * as apis from '../../api/networkDisk'
import { StorageModule } from '../../modules/storage'
import { getImgUrlById } from '../../util'
import user_default from '../../static/image/user_default.png'
import SelectedExecutor from '../../components/executorList/selectedExecutor'
import moment from 'moment'

import {
    nowYear,
    nowMonth,

} from './util';

import { useHistory } from 'react-router-dom';

interface Props {
    history: any;
}
interface State {
    userInfo: any
}


const CalendarView = (props: Props) => {
    const [state, setState] = useState<State>({
        userInfo: {}
    });
    const dataTypeList = [
        { value: 'day', label: '每日' },
        { value: 'week', label: '每周' },
        { value: 'month', label: '每月' },
        { value: 'season', label: '季度' }
    ]
    const [dataType, setDataType] = useState<any>(StorageModule.get('calendarType') || 'day');
    const [list, setList] = useState<any>([]);
    const { store, dispatch } = useStore();
    const [year, setYear] = useState<any>();

    const [tableNums, setTableNums] = useState<any>(12);
    const history = useHistory();

    useEffect(() => {
        if (dataType === 'season') {
            setTableNums(4)
        } else {
            setTableNums(12)
        }
        StorageModule.set('calendarType', dataType)
    }, [dataType])
    useEffect(() => {
        console.log('setYear', year, store.calendarCurTime, store.calendarCurTimeType)
        setYear(moment(store.calendarCurTime).format('YYYY'))
    }, [window.location.hash])
    useEffect(() => {
        getList(year)
    }, [store.calendarExecutorRowKeys, dataType, store.subjectCurType, store.calendarExecutor?.id])
    useEffect(() => {
        if(store.calendarCurTime){
        getList(moment(store.calendarCurTime).format('YYYY'))
        setYear(moment(store.calendarCurTime).format('YYYY'))
        }
    }, [store.calendarCurTime])

    const getList = async (nowY: any = moment(store.calendarCurTime).format('YYYY')) => {
        try {
            state.userInfo = StorageModule.getUser().user
            // console.log(store.calendarExecutorRowKeys)
            let params: any = {
                // type: dataType,
                // executorIds: [state.userInfo.id]
            }
            // 默认：executorIds = [当前登陆用户id]
            // 当前主题的任务：topicIds = [当前主题id]
            // 全部：只有查询开始和结束时间，没有其他的请求参数。
            if (store.subjectCurType === 'default') {
                params.executorIds = [state.userInfo.id]
            }
            if (store.subjectCurType === 'current') {
                params.topicIds = [store.subjectInfo?.subjectId]
            }
            if (store.subjectCurType === 'all') {
                delete params['executorIds']
            }
            if (store.calendarExecutorRowKeys.length > 0) {
                params.executorIds = store.calendarExecutorRowKeys
            }
            if (store.calendarExecutor?.id) {
                params.executorIds = store.calendarExecutor?.id
            }
            let res: any = await apis.statsTask(nowY, dataType, params)
            if (res.ok) {
                setList(res.data)
            }
        } catch { }
    }
    let items = []
    for (var i = 0; i < tableNums; i++) {
        let nums = list.length / tableNums
        items.push(
            <InitDatePicker onRefresh={(e) => {
                console.log(e)
                console.log(dataType)
                StorageModule.set('calendarType', dataType)
                StorageModule.set('calendarCurTimeType', dataType)
                dispatch({
                    type: 'SET_CALENDARCURTIME',
                    data: `${e.year}-${e.month}-${e.date}`
                });
                setTimeout(() => {
                    props.history.push({
                        pathname: `/schedule/${dataType}/${e.year}-${e.month}-${e.date}`,
                        query: {
                            'dataType': dataType,
                            'data': e
                        }
                    })
                }, 200);

            }} currentYear={year} currentMonth={i + 1} taskList={list} taskCount={list[i]?.taskCount} dataType={dataType} />
        );
    }
    const onChange: DatePickerProps['onChange'] = (date, dateString) => {
        console.log(moment(date).format('YYYY-MM-DD'), dateString);
        setYear(dateString)
        dispatch({
            type: 'SET_CALENDARCURTIME',
            data: moment(date).format('YYYY-MM-DD')
        });
        window.location.hash = `/calendar/${moment(date).format("YYYY-MM-DD")}`

    };
    return (
        <div className={styles.box} data-flex='dir:top main:left cross:center'>
            <div data-flex='main:justify cross:center' className={styles.boxTitle} style={{ width: '94%' }}>
                <div className='f22 f-weight '>
                    {/* {nowYear}年 */}
                    <DatePicker allowClear={false} value={moment(`${year}-01-01`)} onChange={onChange} picker="year" />
                </div>
                <div data-flex='main:right cross:center'>
                    <SelectedExecutor onClick={(e) => {
                        console.log(e)
                    }} />
                    <Select
                        defaultValue={dataType}
                        style={{ width: 120 }}
                        onChange={(e) => {
                            // console.log(e)
                            setDataType(e)
                            setList([])
                        }}
                        options={dataTypeList} />
                </div></div>
            <div data-flex='main:center cross:center flex-wrap' style={{ overflow: 'overlay' }}>
                {items}
            </div>
        </div>
    )
}

export default CalendarView
